import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{t('notfound.metadata.title')}</title>
        <meta name="description" content={t('notfound.metadata.description')} />
      </Helmet>
      <div className="flex min-h-screen flex-col items-center justify-center bg-white">
        <img
          src="/logos/ms4all_logo_with_tagline.svg"
          alt="Logo MS4ALL"
          className="mb-14 h-20 w-fit sm:h-32"
        />

        <h1 className="mb-4 text-6xl font-bold text-gray-900">404</h1>

        <p className="mb-8 text-center text-xl text-gray-600">
          {t('notfound.message')}
        </p>

        <button
          onClick={() => navigate('/')}
          className="rounded-lg bg-blue-600 px-6 py-2 text-white transition hover:bg-blue-700"
        >
          {t('notfound.backHome')}
        </button>
      </div>
    </>
  );
}
